import { connect } from 'react-redux';
import _ from 'lodash';
import GlowforgeLandingPage from 'app/components/landing/glowforge-landing-page';
import { getProducts } from 'app/store/selectors/glowforge-order-page';
import { getReferralInfo } from 'app/common/selectors/common';

const mapStateToProps = state => ({
  page: { ..._.get(state, 'landing.glowforgeLandingPage') },
  referralInfo: getReferralInfo(state),
  products: getProducts(state),
});

// Please do all preload in landing-app for performance reasons
// to make all requests in parallel
const GlowforgeLandingPageContainer = connect(mapStateToProps)(GlowforgeLandingPage);

export default GlowforgeLandingPageContainer;



// WEBPACK FOOTER //
// ./app/containers/landing/glowforge-landing.js